import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import {
  CardElement,
  CardNumberElement, 
  CardExpiryElement, 
  CardCvcElement,
  PaymentElement,
  useStripe,
  useElements,
  Elements,
} from '@stripe/react-stripe-js';

import Header from '../components/Header';
import Footer from '../components/Footer';
import { useReportAuth } from '../context/ReportAuthContext';
import { createPaymentIntent, completePayment } from '../services/api';
import { loadStripe } from '@stripe/stripe-js';
import CheckoutFormThree from './CheckoutFormThree';
import StripeCheckout from './StripeCheckout';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || 'pk_test_51Oe7xRFlJQ9qioSs6rief539WY829vcm0W24lnKiettyueuENiQQvEMi8LwY3QxFO1fAIdkdELRhegIR7LVZGBy600UPsHuYKh');

export default function Checkout() {
  const navigate        = useNavigate();
  const stripe          = useStripe();
  const elements        = useElements();
  const {
    searchData,
    selectedReport,
    setCustomerInfo,
    saveReportToken,
  } = useReportAuth();

  // Redirect to home if no search/report selected
  useEffect(() => {
    if (!searchData || !selectedReport) {
      navigate('/', { replace: true });
    }

    window.scrollTo({
    top: 0,
    behavior: "smooth",
  });

  }, [searchData, selectedReport, navigate]);

  const [email,     setEmail]     = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName,  setLastName]  = useState('');
  const [phone,     setPhone]     = useState('');
  const [accepted,  setAccepted]  = useState(false);

  const [clientSecret,     setClientSecret]     = useState(null);
  const [paymentIntentId,  setPaymentIntentId]  = useState(null);
  const [loadingIntent,    setLoadingIntent]    = useState(false);
  const [submitting,       setSubmitting]       = useState(false);
  const [error,            setError]            = useState('');

  if (!searchData || !selectedReport) return null;

  const { plate, state } = searchData;
  const { reportType, price, name } = selectedReport;
  const gst      = +(price * 0.1 / 1.1).toFixed(2);
  const subtotal = +(price - gst).toFixed(2);

  // Create PaymentIntent when user fills required billing fields and blurs email
  async function ensurePaymentIntent() {
    if (clientSecret) return;
    if (!email || !firstName || !lastName) return;

    setLoadingIntent(true);
    setError('');
    try {
      const data = await createPaymentIntent({
        reportType,
        plate,
        state,
        email,
        firstName,
        lastName,
      });
      console.log('data.clientSecret :'+ data.clientSecret);
      console.log('data.paymentIntentId :'+ data.paymentIntentId);
      setClientSecret(data.clientSecret);
      setPaymentIntentId(data.paymentIntentId);
    } catch (err) {
      const msg = err.response?.data?.error || 'Failed to initialise payment. Please try again.';
      setError(msg);
    } finally {
      setLoadingIntent(false);
    }
  }

  async function handleSubmit(e) {
    alert('11');
    e.preventDefault();
    setError('');
alert('12');
    if (!accepted) {
      setError('Please accept the Terms & Conditions to continue.');
      return;
    }
    alert('13');
    if (!stripe || !elements) {
      setError('Payment system not ready. Please wait a moment.');
      return;
    }
    alert('14');
    if (!clientSecret || !paymentIntentId) {
      setError('Payment not initialised. Please fill in your billing details first.');
      return;
    }
alert('15');
    setSubmitting(true);
alert('16');
    try {

      alert('50');
      //const cardElement = elements.create('card', {
  //style: {
    //base: {
      //fontSize: '15px',
      //color: '#1a1a2e',
      //fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      //'::placeholder': { color: '#aab7c4' },
    //},
    //invalid: { color: '#e53e3e' },
  //},
//});

alert('51');

  const cardfullname  = `${firstName} ${lastName}`;
  const cardemail = email;

  alert('52');

  const cardNumberDetails = elements.getElement(CardNumberElement);

  const { paymentMethod, error: pmError } = await stripe.createPaymentMethod({
    type: 'card',
    card: cardNumberDetails,
    billing_details: { cardfullname, cardemail },
  });

    alert('53');

  alert('payment successful');
  alert('54');

  const paymentcardelements = stripe.elements({
  clientSecret: clientSecret // ✅ REQUIRED
});

  stripe.elements({
  clientSecret: clientSecret // ✅ REQUIRED
});

alert('55');
  //elements.create('payment', {
  //});

  //const const_paymentElement = paymentcardelements.create('payment', {
  //fields: {
    //billingdetails: {
      //name: 'never',
      //email: 'never',
      //phone: 'never'
    //}
  //}
//});

  const const_paymentElement = paymentcardelements.create('payment', {
  fields: {
    billingdetails: {
      name: 'never',
      email: 'never',
      phone: 'never'
    }
  }
});

//const PaymentElementDetails = stripe.elements.getElement(PaymentElement);

alert('56');

alert('17');
alert('clientSecret :'+ clientSecret);

      console.log('fullname :'+ `${firstName} ${lastName}`);
      console.log('email :'+ email);
      console.log('phone :'+ (phone || undefined));


      alert('paymentMethodfunction :' + paymentMethod);
      alert('paymentMethod :' + paymentMethod.id);

      const { error, paymentIntent } = await stripe.confirmCardPayment(
  clientSecret,
  {
    payment_method: paymentMethod,
  }
);

      //const { error, paymentIntent } = await stripe.confirmCardPayment(
  //clientSecret,
  //{
    //payment_method: {
      //card: cardNumberDetails,
      //billing_details: {
        //name: `${firstName} ${lastName}`,
        //email: email || undefined,
      //},
    //},
  //}
//);

alert('stripe.confirmCardPayment');
alert(elements);
console.log(elements);
alert(cardNumberDetails);
console.log(cardNumberDetails);

      // Confirm the payment using Stripe.js (card details never touch our server)
      const { error: stripeError } = await stripe.confirmPayment({
        clientSecret: clientSecret,
        confirmParams: {
          return_url: `${window.location.origin}/processing`,
          receipt_email: email,
          payment_method_data: {
            billing_details: {
              name:  `${firstName} ${lastName}`,
              email: email || undefined,
              phone: phone || undefined,
            },
          },
        },
        redirect: 'always',
      });

      alert('18');

      if (stripeError) {
        setError(stripeError.message || 'Payment failed. Please try again.');
        setSubmitting(false);
        return;
      }

      alert('19');

      // Payment succeeded — call our backend to verify and issue JWT
      setCustomerInfo({ email, firstName, lastName, phone });

      alert('20');

      const result = await completePayment({
        paymentIntentId,
        reportType,
        plate,
        state,
        email,
      });

      alert('21');

      saveReportToken(result.token, result.orderId);

      alert('22');

      navigate('/processing');

      alert('23');

    } catch (err) {
      const msg = err.response?.data?.error || err.message || 'An unexpected error occurred.';
      setError(msg);
      setSubmitting(false);
    }
  }

  const paymentElementOptions = {
    layout: 'tabs',
    defaultValues: {
      billingDetails: {
        name:  firstName && lastName ? `${firstName} ${lastName}` : undefined,
        email: email || undefined,
        phone: phone || undefined
      },
    },
  };

  const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      fontSize: '16px',
      color: '#1a1a1a',
      '::placeholder': { color: '#aab7c4' },
    },
    invalid: {
      color: '#e53e3e',
    },
  },
};

const checkoutformdata = {
  clientSecret: clientSecret,
  firstName: firstName,
  lastName: lastName,
  email: email,
  phone: phone,
  reportType: reportType,
  plate: plate,
  state: state,
  paymentIntentId: paymentIntentId
};

const stripecheckoutformdata = {
  reportType: reportType,
  plate: plate,
  state: state,
  subtotal: price,
};

  return (
    <>
      <Header minimal />

      <section className="checkout-section">
        <div className="container">
          <div className="checkout-grid">
            {/* ── Left — Payment Form ── */}
            <div className="checkout-form-wrapper">
              <div className="checkout-header">
                <h1>Complete Your Purchase</h1>
                <p>Secure payment powered by <strong>Stripe</strong></p>
              </div>

<StripeCheckout data={stripecheckoutformdata} />

<div>
</div>
</div>



            {/* ── Right — Order Summary ── */}
            <div className="order-summary-wrapper">
              <div className="order-summary">
                <h3 className="order-summary-title">Order Summary</h3>

                <div className="order-item">
                  <div className="order-item-details">
                    <div className="order-item-name">{name}</div>
                    <div className="order-item-description">
                      <div className="order-vehicle-info">
                        <strong>Vehicle:</strong> {plate}<br />
                        <strong>State:</strong> {state}
                      </div>
                    </div>
                  </div>
                  <div className="order-item-price">${subtotal.toFixed(2)}</div>
                </div>

                <div className="order-features">
                  <h4>What's Included:</h4>
                  <ul>
                    <li><i className="fas fa-check"></i> Official PPSR Certificate</li>
                    <li><i className="fas fa-check"></i> Finance Owing Check</li>
                    <li><i className="fas fa-check"></i> Written Off Records</li>
                    <li><i className="fas fa-check"></i> Stolen Vehicle Check</li>
                    <li><i className="fas fa-check"></i> VIN Validation</li>
                    {reportType === 'comprehensive' && (
                      <>
                        <li><i className="fas fa-check"></i> Odometer History</li>
                        <li><i className="fas fa-check"></i> Registration Timeline</li>
                        <li><i className="fas fa-check"></i> Market Valuation</li>
                      </>
                    )}
                  </ul>
                </div>

                <div className="order-total">
                  <div className="order-total-row">
                    <span>Subtotal</span>
                    <span>${subtotal.toFixed(2)}</span>
                  </div>
                  <div className="order-total-row">
                    <span>GST (10%)</span>
                    <span>${gst.toFixed(2)}</span>
                  </div>
                  <div className="order-total-row order-total-final">
                    <span>Total (AUD)</span>
                    <span>${price.toFixed(2)}</span>
                  </div>
                </div>

                <div className="order-guarantees">
                  <div className="guarantee-item"><i className="fas fa-bolt"></i><span>Instant delivery</span></div>
                  <div className="guarantee-item"><i className="fas fa-file-pdf"></i><span>PDF download</span></div>
                  <div className="guarantee-item"><i className="fas fa-envelope"></i><span>Email copy</span></div>
                </div>

                <button className="btn-link" onClick={() => navigate('/report-types')}>
                  <i className="fas fa-arrow-left"></i> Change Report Type
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Trust Badges */}
      <section className="checkout-trust">
        <div className="container">
          <div className="trust-badges-row">
            {[
              { icon: 'fab fa-stripe',       label: 'Powered by Stripe' },
              { icon: 'fas fa-lock',          label: '256-bit SSL Encrypted' },
              { icon: 'fas fa-shield-alt',    label: 'PCI DSS Compliant' },
              { icon: 'fas fa-check-circle',  label: 'Secure Payment' },
            ].map((b) => (
              <div key={b.label} className="trust-item">
                <i className={b.icon}></i>
                <span>{b.label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer minimal />
    </>
  );
}
